import { request } from '../../network';
import { getKsAndWaitIfRefreshing } from '../../phoenix/network/deferRefreshKs';
import { JSONValue } from '../../util';
import type { ContextConfiguration } from '../inputs';

import { experienceConfig } from './experienceConfig';
import { handleExperienceErrors } from './handleExperienceErrors';
import { ExperienceApiResponse } from './type';

type VariablesTypes = { [x: string]: JSONValue } & { config?: ContextConfiguration };

function getVariables(language: string, variables?: VariablesTypes) {
  if (!variables) {
    return {
      config: {
        language,
      },
    };
  }

  const { config, ...rest } = variables;

  return {
    config: {
      language,
      ...config,
    },
    ...rest,
  };
}

export async function requestExperience<T>(query: string, variables?: VariablesTypes) {
  const ks = await getKsAndWaitIfRefreshing();
  const { clientTag, graphQlUrl, language } = experienceConfig;
  const queryParams = {
    clientTag,
  };
  const response = await request<ExperienceApiResponse<T>>({
    url: graphQlUrl,
    queryParams,
    method: 'post',
    headers: {
      authorization: `Bearer ${ks}`,
    },
    body: {
      query,
      variables: getVariables(language, variables),
    },
  });

  handleExperienceErrors(response);

  return response;
}
